document.addEventListener('DOMContentLoaded', function () {
    if (window.isSlidesDuplicated) {
return;
}
    window.isSlidesDuplicated = true;
    const widgets = document.querySelectorAll('.c-voices-slider');
    widgets.forEach(function (e) {
        const widgetId = e.getAttribute('data-widget-id');
        duplicateSlides(widgetId);
    });
});

function duplicateSlides(widgetId) {
    const logosContainer = document.getElementById('slider' + widgetId);
    const slideElement = document.getElementById('track' + widgetId);
    for (let i = 0; i < 2; i++) {
        let clone = slideElement.cloneNode(true);
        logosContainer.appendChild(clone);
    }
}
